import React from 'react';
import { Tolgee, DevTools, TolgeeProvider as Provider, FormatSimple } from '@tolgee/react';
import { useSelector } from 'react-redux';
import { createLogger } from '@rakutenfrance/logger';
import { FALLBACK_LANGUAGE } from '../../constants';
const logger = createLogger('tolgee-provider');
export const getTolgee = ({ language, apiKey, apiUrl, ns, staticData, }) => {
    const tolgee = Tolgee().use(DevTools()).use(FormatSimple()).init({
        language,
        apiKey,
        apiUrl,
        ns,
        staticData,
        defaultLanguage: FALLBACK_LANGUAGE,
    });
    return tolgee;
};
export const TolgeeProvider = ({ children, ns, apiKey, apiUrl, staticData }) => {
    const language = useSelector((state) => { var _a; return (_a = state.tolgee) === null || _a === void 0 ? void 0 : _a.language; }) || FALLBACK_LANGUAGE;
    const ssrStaticData = useSelector((state) => { var _a; return (_a = state.tolgee) === null || _a === void 0 ? void 0 : _a.ssrStaticData; });
    const nsFromRedux = ssrStaticData === null || ssrStaticData === void 0 ? void 0 : ssrStaticData.map((cachedTolgee) => cachedTolgee.namespace);
    let useNs;
    if (nsFromRedux && nsFromRedux.length > 0) {
        useNs = nsFromRedux;
    }
    else {
        useNs = ns;
    }
    // console.log('TolgeeProvider', language, useNs);
    const tolgee = getTolgee({ apiKey, apiUrl, language, ns: useNs, staticData });
    let useStaticData;
    if (ssrStaticData !== undefined && (ssrStaticData === null || ssrStaticData === void 0 ? void 0 : ssrStaticData.length) > 0) {
        useStaticData = ssrStaticData;
    }
    else {
        useStaticData = staticData;
    }
    logger.debug('TolgeeProvider useStaticData', useStaticData);
    return (React.createElement(Provider, { tolgee: tolgee, ssr: { language: language, staticData: useStaticData } }, children));
};
